module.exports = __webpack_public_path__ + "media/images/vp/icon.hours.red-ef1ac57d5e97f7591d145d8f1f372e52.png";